
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace/[id]",
      function () {
        return require("private-next-pages/workspace/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace/[id]"])
      });
    }
  